module.exports = __webpack_public_path__ + "../resources/img/bg-copy-2-light.d4eb6f92.svg";